/**
 * @file: ContactPickerPanel.tsx
 *
 * The "通讯录" panel opened from the inbox header — single-tap a colleague to
 * open (or resume) a 1:1 chat. A thin `BottomPanel` wrapper around the shared
 * `ChatContactPickerView` in `direct` mode; the picked contact is handed back
 * via `onSelect` and the host does the routing.
 */

import { BottomPanel } from '@euler/components/BottomPanel';
import { ChatContact } from '@euler/model/chat';
import { FC, memo } from 'react';
import { ChatContactPickerView } from '../pages/contact-picker/components/ChatContactPickerView';

export const ContactPickerPanel: FC<{
  visible: boolean;
  onClose: () => void;
  onSelect: (contact: ChatContact) => void;
}> = memo(({ visible, onClose, onSelect }) => (
  <BottomPanel visible={visible} onClose={onClose}>
    <ChatContactPickerView
      embedded
      params={{ mode: { kind: 'direct' } }}
      onDone={result => {
        if (result.kind === 'direct') onSelect(result.contact);
      }}
      onCancel={onClose}
    />
  </BottomPanel>
));
